import { useMemo } from "react";
import type { Dictionary } from "lodash";
import type { CategoryType, PackType } from "../../../../common-deprecated/types/CommonTypes";
import { useCarConfigSelector } from "../redux/store";
import { getPackItems } from "../../../shared-logic/utils/packUtils";
import Debug from "../../../../common-deprecated/Debug";
import { groupPacksByCategory, sortCategories } from "../utils/packUtils";

export const useAphPacks = (
    packs: PackType[],
    enabledCategoryFilters: CategoryType[],
): {
    categorized: [string, Dictionary<PackType[]>][];
    valid: PackType[];
} => {
    const navigationPath = useCarConfigSelector(
        (state) =>
            `${state.carConfigNavigation.step}/${state.carConfigNavigation.modelId}/${
                state.carConfigNavigation.carId as string
            }`,
    );
    const basket = useCarConfigSelector((state) => state.basket);
    const financeOption = useCarConfigSelector((state) => state.utils.financeOption);
    const upholsteries = useCarConfigSelector((state) => state.items.upholsteries);

    const validPacks = packs.filter((pack) => {
        const packContent = getPackItems(pack, basket, upholsteries, financeOption);
        if (
            packContent.renderedEquipment.length <= 0 &&
            packContent.optionalEquipment.length <= 0 &&
            packContent.wheels.length <= 0 &&
            packContent.upholsteries.length <= 0 &&
            packContent.colours.length <= 0
        ) {
            Debug.warn(`Pack ${pack.name} doesn't have any items and is not shown`, {
                path: navigationPath,
                packId: pack.id,
                status: "warning",
            });
            return false;
        }
        return true;
    });

    return useMemo(
        () => ({
            valid: validPacks,
            categorized: Object.entries(groupPacksByCategory(validPacks, enabledCategoryFilters)).sort(sortCategories),
        }),
        [validPacks, enabledCategoryFilters],
    );
};
